import { oc } from 'ts-optchain';

import ClowncarAppConstants from 'constants/ClowncarAppConstants';

const initialState = {
  isInitialized: false,
  response: {
    count: 0,
    result: [],
  },
};

export default function reducer(state = initialState, action: BaseTockAction) {
  const { type, payload, context } = action;
  switch (type) {
    case ClowncarAppConstants.PATRONS_SEARCH_DONE: {
      return {
        ...state,
        isInitialized: true,
        response: payload,
      };
    }
    case ClowncarAppConstants.PATRONS_SEARCH_STARTING: {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      if ((oc(context) as any).isInitialRequest()) {
        return {
          ...state,
          isInitialized: false,
          response: {
            result: [],
          },
        };
      }
      return {
        ...state,
        isInitialized: false,
      };
    }
    case ClowncarAppConstants.INTERNAL_ACCOUNT_DELETE_FAILED:
    case ClowncarAppConstants.INTERNAL_ACCOUNT_STATUS_UPDATE_FAILED:
    case ClowncarAppConstants.INTERNAL_GLOBAL_TEXTING_UNSUBSCRIBE_FAILED:
    case ClowncarAppConstants.PATRON_RESET_FAILED_LOGIN_ATTEMPTS_FAILED:
    case ClowncarAppConstants.PATRONS_SEARCH_FAILED: {
      return {
        ...state,
        isInitialized: true,
      };
    }
    case ClowncarAppConstants.INTERNAL_ACCOUNT_DELETE_STARTING:
    case ClowncarAppConstants.INTERNAL_GLOBAL_TEXTING_UNSUBSCRIBE_STARTING:
    case ClowncarAppConstants.PATRON_RESET_FAILED_LOGIN_ATTEMPTS_STARTING:
    case ClowncarAppConstants.INTERNAL_ACCOUNT_STATUS_UPDATE_STARTING: {
      return {
        ...state,
        isInitialized: false,
      };
    }
    case ClowncarAppConstants.INTERNAL_ACCOUNT_STATUS_UPDATE_DONE:
    case ClowncarAppConstants.INTERNAL_ACCOUNT_DELETE_DONE:
    case ClowncarAppConstants.PATRON_RESET_FAILED_LOGIN_ATTEMPTS_DONE:
    case ClowncarAppConstants.INTERNAL_GLOBAL_TEXTING_UNSUBSCRIBE_DONE: {
      return {
        ...state,
        isInitialized: true,
        response: {
          count: 0,
          result: [],
        },
      };
    }
    default:
      return state;
  }
}
